module.exports = __webpack_public_path__ + "img/enrolment@3x.d43b916d.png";